import Discord from './discord.svg';
import Facebook from './facebook.svg';
import Github from './github.svg';
import Medium from './medium.svg';
import Reddit from './reddit.svg';
import station from './station.svg';
import Telegram from './telegram.svg';
import Twitter from './x.svg';
import Others from './others.svg';

export { Discord, Facebook, Github, Medium, Reddit, station, Telegram, Twitter, Others };
